import { type JSX, Match, Switch } from 'solid-js';
import { t } from '../../i18n';
import { useAcceptedMoves } from '../../lib/accepted-move';
import { MoveIcon } from './MoveIcon';

// A moved row's tag (#6772, prototype flight `:1645`, `JOBTAG` moving / moved): "Moving" with a
// 10 px spinner and a shimmering title while the task's `move.state` is `checkpointing` or
// `moving`, held at least 1,100 ms; then "Moved" with a check for 2,300 ms (`AcceptedMoves.tagOf`).
// Only tasks this page follows are tagged. Under reduced motion "Moving" is plain accent text
// (the stylesheet's `reduce-motion`). "Moved" is not green: green is for merged and shipped.

export function MoveTag(props: { readonly taskId: string }): JSX.Element {
  const a = useAcceptedMoves();
  const tag = () => a?.tagOf(props.taskId) ?? null;
  return (
    <Switch>
      <Match when={tag() === 'moving'}>
        <span class="move-tag move-tag--live">
          <i class="move-tag__spin" aria-hidden="true" />
          {t('fleet.move.tag_moving')}
        </span>
      </Match>
      <Match when={tag() === 'moved'}>
        <span class="move-tag move-tag--moved">
          <MoveIcon glyph="check" />
          {t('fleet.move.tag_moved')}
        </span>
      </Match>
    </Switch>
  );
}
